import BaseApiRepository from "repositories/api/BaseApiRepository";
import {
    AppointmentApprove,
    AppointmentCounts,
    ApprovedAppointment,
    DeclinedAppointment,
} from "../interfaces/AppointmentApproveInterfaces";
import { AppNotificationService } from "services/AppNotificationService";

const BASE_URL = "appointments-approve/";

export class Repository {
    
    static getDepartmentIdsAsync = async (): Promise<number[]> => {
        const response = (await BaseApiRepository.getAsync(`${BASE_URL}department`)) as Response;
        if (!response.ok) {
            AppNotificationService.addWarningNotification("En feil oppstod ved henting av losstasjoner");
            throw new Error("Failed to get departments");
        }
        const result = await response.json();
        return result;
    };

    static getAppointmentsReadyForApprovalAsync = async (): Promise<AppointmentApprove[]> => {
        const departmentIds = await this.getDepartmentIdsAsync();

        const response = (await BaseApiRepository.postAsync(
            `${BASE_URL}ready-for-approval`,
            departmentIds,
        )) as Response;
        if (!response.ok) {
            AppNotificationService.addWarningNotification("En feil oppstod ved henting av frav&aelig;r");
            throw new Error("Failed to get appointments ready for approval");
        }

        const result = (await response.json()) as AppointmentApprove[];
        return result;
    };

    static approveAppointmentsAsync = async (approveIds: ApprovedAppointment[]): Promise<void> => {
        const response = await BaseApiRepository.postAsync(`${BASE_URL}approve`, approveIds);
        if (!response.ok) {
            AppNotificationService.addWarningNotification("En feil oppstod ved godkjenning av frav&aelig;r");
            throw new Error("Failed to approve appointment");
        }
    };

    static declineAppointmentsAsync = async (declineIds: DeclinedAppointment[]): Promise<void> => {
        const response = await BaseApiRepository.postAsync(`${BASE_URL}decline`, declineIds);
        if (!response.ok) {
            AppNotificationService.addWarningNotification("En feil oppstod ved avvisning av frav&aelig;r");
        }
    };

    static getReadyForApprovalCountAsync = async (): Promise<AppointmentCounts> => {
        const departmentIds = await this.getDepartmentIdsAsync();

        const response = (await BaseApiRepository.postAsync(
            `${BASE_URL}ready-for-approval/count`,
            departmentIds,
        )) as Response;
        if (!response.ok) {
            return { total: 0, due: 0 };
        }

        const result = await response.json();
        return result;
    };

    static getProcessedAppointmentsAsync = async (offset = 0, limit = 50): Promise<AppointmentApprove[]> => {
        const departmentIds = await this.getDepartmentIdsAsync();

        const response = (await BaseApiRepository.postAsync(
            `${BASE_URL}processed?offset=${offset}&limit=${limit}`,
            departmentIds,
        )) as Response;
        if (!response.ok) {
            AppNotificationService.addWarningNotification("En feil oppstod ved henting av frav&aelig;r");
            throw new Error("Failed to get appointments ready for approval");
        }

        const result = await response.json();
        return result;
    };
}
